import React from 'react';
import clsx from 'clsx';

type chipColor = 'danger' | 'success' | 'warning' | 'info';

const Chip = ({
  children,
  color,
  className,
  style,
}: {
  children: React.FC | JSX.Element | string | null;
  color?: chipColor;
  className?: string;
  style?: React.CSSProperties;
}): JSX.Element => {
  return (
    <span
      style={style}
      className={clsx(
        'min-w-75 inline-block m-0 rounded-full py-8 px-15 text-xxs text-center leading-none',
        className,
        {
          'bg-red-50 text-red-500': color === 'danger',
          'bg-green-300 text-green-400': color === 'success',
          'bg-gray-100 text-gray-300': !color,
          'bg-orange-100 text-orange-200': color === 'warning',
        }
      )}
    >
      {children}
    </span>
  );
};

export default Chip;
